import { useAuth } from '../AuthContext';

/**
 * usePermissions — returns per-section permission flags based on JWT claims.
 *
 * Claim format: 'User{Action} {Section}'
 * Actions : Create | Edit | Delete | Read | Cancel
 * Sections: Master | Transaction | Accounts | Reports | Administration | AdminReports
 *
 * SuperAdmin (isSuperAdmin) and the privileged username 'Baiju_Ta'
 * receive full access to everything.
 *
 * Usage:
 *   const { canCreate, canEdit, canDelete, canRead, canCancel } = usePermissions('Master');
 */
const usePermissions = (section) => {
  const { permissions, isSuperAdmin, username } = useAuth();

  const hasFullAccess = isSuperAdmin || username === 'Baiju_Ta';

  if (hasFullAccess) {
    return {
      canRead:   true,
      canCreate: true,
      canEdit:   true,
      canDelete: true,
      canCancel: true,
    };
  }

  return {
    canRead:   permissions.includes(`UserRead ${section}`),
    canCreate: permissions.includes(`UserCreate ${section}`),
    canEdit:   permissions.includes(`UserEdit ${section}`),
    canDelete: permissions.includes(`UserDelete ${section}`),
    canCancel: permissions.includes(`UserCancel ${section}`),
  };
};

export default usePermissions;
